import { CarsLink, CarTag, CatalogListLink } from '../types/brandSchema';

export const PopularTruckTyresSizes: CarsLink[] = [
  {
    title: 'R16',
    tags: [
      { title: '7 R16', href: '/catalog/trucktyres/all_sizes/7--16/' },
      { title: '7.5 R16', href: '/catalog/trucktyres/all_sizes/7.5--16/' },
      { title: '8.25 R16', href: '/catalog/trucktyres/all_sizes/8.25--16/' },
    ],
  },
  {
    title: 'R17.5',
    tags: [
      {
        title: '215/75 R17.5',
        href: '/catalog/trucktyres/all_sizes/215-75-17.5/',
      },
      {
        title: '225/75 R17.5',
        href: '/catalog/trucktyres/all_sizes/225-75-17.5/',
      },
      {
        title: '235/75 R17.5',
        href: '/catalog/trucktyres/all_sizes/235-75-17.5/',
      },
      {
        title: '245/70 R17.5',
        href: '/catalog/trucktyres/all_sizes/245-70-17.5/',
      },
    ],
  },
  {
    title: 'R19.5',
    tags: [
      {
        title: '245/70 R19.5',
        href: '/catalog/trucktyres/all_sizes/245-70-19.5/',
      },
      {
        title: '265/70 R19.5',
        href: '/catalog/trucktyres/all_sizes/265-70-19.5/',
      },
      {
        title: '285/70 R19.5',
        href: '/catalog/trucktyres/all_sizes/285-70-19.5/',
      },
    ],
  },
  {
    title: 'R20',
    tags: [
      {
        title: '8.25 R20',
        href: '/catalog/trucktyres/all_sizes/8.25--20/',
      },
      {
        title: '9 R20',
        href: '/catalog/trucktyres/all_sizes/9--20/',
      },
      {
        title: '10 R20',
        href: '/catalog/trucktyres/all_sizes/10--20/',
      },
      {
        title: '11 R20',
        href: '/catalog/trucktyres/all_sizes/11--20/',
      },
      {
        title: '12 R20',
        href: '/catalog/trucktyres/all_sizes/12--20/',
      },
    ],
  },
  {
    title: 'R22.5',
    tags: [
      {
        title: '11 R22.5',
        href: '/catalog/trucktyres/all_sizes/11--22.5/',
      },
      {
        title: '13 R22.5',
        href: '/catalog/trucktyres/all_sizes/13--22.5/',
      },
      {
        title: '295/80 R22.5',
        href: '/catalog/trucktyres/all_sizes/295-80-22.5/',
      },
      {
        title: '315/60 R22.5',
        href: '/catalog/trucktyres/all_sizes/315-60-22.5/',
      },
      {
        title: '315/70 R22.5',
        href: '/catalog/trucktyres/all_sizes/315-70-22.5/',
      },
      {
        title: '385/65 R22.5',
        href: '/catalog/trucktyres/all_sizes/385-65-22.5/',
      },
    ],
  },
];

export const TruckTyresSize: CarTag[] = [
  { title: 'R8', href: '/catalog/trucktyres/r8/' },
  { title: 'R9', href: '/catalog/trucktyres/r9/' },
  { title: 'R10', href: '/catalog/trucktyres/r10/' },
  { title: 'R12', href: '/catalog/trucktyres/r12/' },
  { title: 'R13', href: '/catalog/trucktyres/r13/' },
  { title: 'R15', href: '/catalog/trucktyres/r15/' },
  { title: 'R15.3', href: '/catalog/trucktyres/r15.3/' },
  { title: 'R15.5', href: '/catalog/trucktyres/r15.5/' },
  { title: 'R16', href: '/catalog/trucktyres/r16/' },
  { title: 'R16.1', href: '/catalog/trucktyres/16.1/' },
  { title: 'R16.5', href: '/catalog/trucktyres/r16.5/' },
  { title: 'R17.5', href: '/catalog/trucktyres/r17.5/' },
  { title: 'R18', href: '/catalog/trucktyres/r18/' },
  { title: 'R19.5', href: '/catalog/trucktyres/r19.5/' },
  { title: 'R20', href: '/catalog/trucktyres/r20/' },
  { title: 'R21', href: '/catalog/trucktyres/r21/' },
  { title: 'R22.5', href: '/catalog/trucktyres/r22.5/' },
  { title: 'R24', href: '/catalog/trucktyres/r24/' },
  { title: 'R25', href: '/catalog/trucktyres/r25/' },
  { title: 'R26', href: '/catalog/trucktyres/r26/' },
  { title: 'R26.5', href: '/catalog/trucktyres/r26.5/' },
  { title: 'R28', href: '/catalog/trucktyres/r28/' },
  { title: 'R30', href: '/catalog/trucktyres/r30/' },
  { title: 'R32', href: '/catalog/trucktyres/r32/' },
  { title: 'R34', href: '/catalog/trucktyres/r34/' },
  { title: 'R38', href: '/catalog/trucktyres/r38/' },
  { title: 'R42', href: '/catalog/trucktyres/r42/' },
  { title: 'R54', href: '/catalog/trucktyres/r54/' },
  { title: 'R508', href: '/catalog/trucktyres/r508/' },
  { title: 'R533', href: '/catalog/trucktyres/r533/' },
];

export const TruckTyresByPurpose: CarTag[] = [
  { title: 'Ведущая', href: '/catalog/trucktyres/axis/1/' },
  { title: 'Универсальная', href: '/catalog/trucktyres/axis/2/' },
  { title: 'Прицепная', href: '/catalog/trucktyres/axis/3/' },
  { title: 'Рулевая', href: '/catalog/trucktyres/axis/4/' },
  { title: 'Пневматическая', href: '/catalog/trucktyres/axis/6/' },
  { title: 'Рулевая M+S', href: '/catalog/trucktyres/axis/9/' },
  { title: 'Ведущая M+S', href: '/catalog/trucktyres/axis/10/' },
  { title: 'Прицепная M+S', href: '/catalog/trucktyres/axis/11/' },
  { title: 'Универсальная M+S', href: '/catalog/trucktyres/axis/12/' },
  { title: 'Прицепная 3PSF', href: '/catalog/trucktyres/axis/13/' },
  { title: 'Ведущая 3PSF', href: '/catalog/trucktyres/axis/14/' },
  { title: 'Прицепная M+S', href: '/catalog/trucktyres/axis/20/' },
  { title: 'Ведущая 3PMSF', href: '/catalog/trucktyres/axis/27/' },
];

export const TypeTruckTyres: CarTag[] = [
  { title: 'Региональная M+S', href: '/catalog/trucktyres/type/1/' },
  { title: 'Региональная', href: '/catalog/trucktyres/type/3/' },
  { title: 'Индустриальная', href: '/catalog/trucktyres/type/5/' },
  { title: 'Строительная', href: '/catalog/trucktyres/type/6/' },
  { title: 'M+S', href: '/catalog/trucktyres/type/8/' },
  { title: 'Строительная M+S', href: '/catalog/trucktyres/type/9/' },
  { title: 'Сельскохозяйственная', href: '/catalog/trucktyres/type/15/' },
  { title: 'Карьерная', href: '/catalog/trucktyres/type/20/' },
];

export const CatalogListTruckTyres: CatalogListLink[] = [
  {
    title: 'Рулевая',
    image: '/next/image/helms.png',
    href: '/catalog/filter/trucktyres/?trucktyres_axle%5B%5D=4&trucktyres_axle%5B%5D=5&trucktyres_axle%5B%5D=9',
    testid: 'trucktyres-axis-4',
  },
  {
    title: 'Ведущая',
    image: '/next/image/lead.png',
    href: '/catalog/filter/trucktyres/?trucktyres_axle%5B%5D=1&trucktyres_axle%5B%5D=10&trucktyres_axle%5B%5D=27',
    testid: 'trucktyres-axis-1',
  },
  {
    title: 'Прицепная',
    image: '/next/image/trail.png',
    href: '/catalog/filter/trucktyres/?trucktyres_axle%5B%5D=3&trucktyres_axle%5B%5D=5&trucktyres_axle%5B%5D=11&trucktyres_axle%5B%5D=20&trucktyres_axle%5B%5D=13',
    testid: 'trucktyres-axis-3',
  },
  {
    title: 'Универсальная',
    image: '/next/image/universyl.png',
    href: '/catalog/filter/trucktyres/?trucktyres_axle%5B%5D=2&trucktyres_axle%5B%5D=12&trucktyres_axle%5B%5D=25',
    testid: 'trucktyres-axis-2',
  },
  {
    title: 'Строительная',
    image: '/next/image/constr.png',
    href: '/catalog/trucktyres/type/6/',
    testid: 'trucktyres-type-6',
  },
];

export const discountImg = [
  { name: 'скидка на шины pirreli', img: '/next/imgDiscount/perelli.png' },
  { name: 'хранение в подарок', img: '/next/imgDiscount/storage.png' },
  { name: 'бесплатный шиномонтаж', img: '/next/imgDiscount/services.png' },
  { name: 'скидка', img: '/next/imgDiscount/discount.png' },
  {
    name: 'бесплатный шиномонтаж и хранение',
    img: '/next/imgDiscount/free.png',
  },
  { name: 'рассрочка', img: '/next/imgDiscount/plan.png' },
  { name: 'плати частями', img: '/next/imgDiscount/parts.png' },
  { name: 'летняя выгода', img: '/next/imgDiscount/summer.png' },
];
